import DocumentsTable from "./DocumentsTableContainer";

export default DocumentsTable;
